import request from '@/utils/request'

// 查询列表
export function apiGetComponentCenterOutOfStockList (query) {
  return request({
    url: '/mes/componentCenterOutOfStock/reportList',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiComponentCenterOutOfStockExport (data) {
  return request({
    url: '/mes/componentCenterOutOfStock/v2/export',
    method: 'post',
    data: data
  })
}
